import { Redirect } from 'expo-router';

/**
 * The Create tab's button is intercepted by GlobalFloatingTabBar (it opens
 * CreateActionSheet instead of navigating), so this route is only reachable
 * via a direct URL. The old placeholder rendered a dead "Add Photo" card —
 * forward straight to the real create flow instead.
 */
export default function CreateScreen() {
  return <Redirect href="/post/create" />;
}
